module.exports = __webpack_public_path__ + "img/CherryCashFreeGames_DG.7ef6062d.jpg";